import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Services } from "@/components/Services";
import { Stats } from "@/components/Stats";
import { Gallery } from "@/components/Gallery";
import { Reviews } from "@/components/Reviews";
import { About } from "@/components/About";
import { Footer } from "@/components/Footer";
import { openSquareBooking } from "@/lib/api";

export default function Landing() {
  const openBooking = () => openSquareBooking();

  return (
    <div className="grain relative bg-barber-bg">
      <Navbar onBook={openBooking} />
      <Hero onBook={openBooking} />
      <Marquee />
      <Services onBook={openBooking} />
      <Stats />
      <Gallery onBook={openBooking} />
      <Reviews />
      <About />
      <Footer />
    </div>
  );
}
